import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { LETTER_TEMPLATES } from "@/components/tools/phrasebookData";

// My signature, my own saved lines, and the ready-made ones to drop into a letter.
export const LetterTemplates = ({ signature, onSignature, onSaveSignature, onInsert,
                                 myTemplates, newTemplate, onNewTemplate, onSaveTemplate,
                                 onRemoveTemplate }) => (
  <div className="mt-2 space-y-3 rounded-2xl border border-white/10 bg-page p-4" data-testid="letter-templates">
    <div>
      <p className="text-[11px] uppercase tracking-widest text-brand">My signature</p>
      <Textarea
        data-testid="signature-input"
        value={signature}
        rows={3}
        maxLength={600}
        onChange={(e) => onSignature(e.target.value)}
        placeholder={"Maria Nguyen\nOperations Lead, ChatMiLu\n+84 90 123 4567"}
        className="mt-1.5 min-h-[76px] w-full resize-y rounded-xl text-sm"
      />
      <div className="mt-2 flex flex-wrap gap-2">
        <Button
          data-testid="save-signature-button"
          variant="outline"
          onClick={onSaveSignature}
          className="min-h-[38px] rounded-full px-5 text-xs active:scale-95"
        >
          Save signature
        </Button>
        <button
          data-testid="insert-signature-button"
          onClick={() => signature.trim() && onInsert(signature.trim())}
          className="rounded-full border border-brand/30 bg-brand/10 px-4 py-1.5 text-xs font-semibold text-brand transition-colors hover:bg-brand/20"
        >
          Drop it in
        </button>
        <span className="self-center text-xs text-ink-soft">
          Added to every reply MiLu drafts for you.
        </span>
      </div>
    </div>

    <div>
      <p className="text-[11px] uppercase tracking-widest text-brand">My lines</p>
      <div className="mt-1.5 flex flex-wrap gap-1.5" data-testid="my-templates">
        {myTemplates.map((t) => (
          <span
            key={t.template_id}
            className="group inline-flex items-center gap-1.5 rounded-full border border-brand/30 bg-brand/10 px-3 py-1.5 text-xs text-brand"
          >
            <button
              data-testid={`my-template-${t.template_id}`}
              onClick={() => onInsert(t.text)}
              title="Add this line to my text"
            >
              {t.text}
            </button>
            <button
              data-testid={`delete-template-${t.template_id}`}
              onClick={() => onRemoveTemplate(t)}
              aria-label="Remove this line"
              className="opacity-60 hover:opacity-100"
            >
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
        {myTemplates.length === 0 && (
          <span className="text-xs text-ink-soft">
            Nothing saved yet — type your own sign-off below and keep it.
          </span>
        )}
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        <input
          data-testid="new-template-input"
          value={newTemplate}
          maxLength={200}
          onChange={(e) => onNewTemplate(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSaveTemplate()}
          placeholder="e.g. Warmest regards, Maria"
          className="min-h-[38px] flex-1 rounded-full border border-white/10 bg-panel px-4 text-sm outline-none placeholder:text-ink-soft focus:border-brand/50"
        />
        <Button
          data-testid="save-template-button"
          variant="outline"
          onClick={onSaveTemplate}
          className="min-h-[38px] rounded-full px-5 text-xs active:scale-95"
        >
          Save line
        </Button>
      </div>
    </div>

    {LETTER_TEMPLATES.map((group) => (
      <div key={group.label}>
        <p className="text-[11px] uppercase tracking-widest text-ink-soft">{group.label}</p>
        <div className="mt-1.5 flex flex-wrap gap-1.5">
          {group.lines.map((line) => (
            <button
              key={line}
              data-testid={`template-${line.slice(0, 14)}`}
              onClick={() => onInsert(line)}
              title="Add this line to my text"
              className="rounded-full border border-white/10 px-3 py-1.5 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
            >
              {line}
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);
